// extracted by mini-css-extract-plugin
export default {"container":"container_C9qI7","title":"title_OGc5D","list":"list_vNrOZ","item":"item_Lbroh","isSmall":"isSmall_Kh5HI"};